import { Point, Size } from './types';

// half sizes for easier calculations
export const controlSize = 3.5;
export const rotateControlSize = 17.5;

export const generateControlPointPath = (center: Point, size: Size): string => {
  return `
  ${center.x - size.width},${center.y - size.height}
   ${center.x + size.width},${center.y - size.height}
    ${center.x + size.width},${center.y + size.height}
     ${center.x - size.width},${center.y + size.height}`;
};

export const isInside = (
  point: Point,
  startPoint: Point,
  size: Size
): boolean => {
  return (
    point.x >= startPoint.x &&
    point.y >= startPoint.y &&
    point.x <= startPoint.x + size.width &&
    point.y <= startPoint.y + size.height
  );
};

export const rotatePoint = (
  point: Point,
  rotationCenter: Point,
  angleInDegrees: number
): Point => {
  const angleInRadians = (angleInDegrees * Math.PI) / 180;

  const newX = point.x - rotationCenter.x;
  const newY = point.y - rotationCenter.y;

  const cos = Math.cos(angleInRadians);
  const sin = Math.sin(angleInRadians);

  return {
    x: newX * cos - newY * sin + rotationCenter.x,
    y: newX * sin + newY * cos + rotationCenter.y,
  };
};
